import { User } from '@prisma/client'
import { Form, Switch, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { FeatureFormConfigurationClient } from '~/features/formConfiguration/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepDailySourceLeads: React.FC<Props> = ({ user, ...props }) => {
  const configuration = { timezone: user.timezone }

  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          Should I source new leads every day?
        </TitlePrimary>

        <Form.Item name={['daily', 'activated']} rules={[{ required: true }]}>
          <Switch checkedChildren="Yes" unCheckedChildren="No" />
        </Form.Item>

        <Form.Item shouldUpdate={true}>
          {options => {
            const isActive = options.getFieldValue(['daily', 'activated'])

            if (!isActive) {
              return <></>
            }

            return (
              <>
                <div className="mb-10">
                  <Typography.Text>
                    ✨ Great, everyday I'll source new leads to contact
                  </Typography.Text>
                </div>
                <Form.Item
                  name={['daily', 'rule']}
                  label="Choose a time that works best for you"
                  rules={[{ required: true }]}
                  getValueFromEvent={items => items[0]}
                >
                  <FeatureFormConfigurationClient.RRulePicker
                    type="DAILY"
                    formValuesConfiguration={configuration}
                  />
                </Form.Item>
              </>
            )
          }}
        </Form.Item>

        <TitlePrimary level={4}>
          Should I contact the leads I source straight away?
        </TitlePrimary>
        <Form.Item name={['daily', 'autopilot']} rules={[{ required: true }]}>
          <Switch checkedChildren="Yes" unCheckedChildren="No" />
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
